import {
    RaikoGridOneColumn,
    RaikoDatePicker,
    RaikoMoneyInputOutlined,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoMobileInputOutlined,
    RaikoMaterialOutlinedInput,
    RaikoGridThreeColumn,
    showErrorMessage,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoSimpleMultiLineInputOutlined,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components"

import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {ContactUsService} from "../../serverService/contactUsService/ContactUsService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";

export default function ShowMessageInfo({messageId, setRefresh, handleCloseDialog}) {


    const [postingDate, setPostingDate] = useState("");
    const [title, setTitle] = useState("");
    const [fullName, setFullName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [email, setEmail] = useState("")
    const [status, setStatus] = useState("AWAITING_FOR_REVIEW")
    const [description, setDescription] = useState("")
    const service = new ContactUsService()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const [buttonLoading, setButtonLoading] = useState(false)


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMessageInfoFromServer()
        }
    }, []);

    function getMessageInfoFromServer() {
        loading.show()
        service.getMessageInfo(messageId).then(
            response => {
                setTitle(response.title)
                setFullName(response.firstName)
                setPhoneNumber(response.phoneNumber)
                setEmail(response.email)
                setPostingDate(convertUniversalDateToPersianDate(response.sendAt))
                setStatus(response.status)
                setDescription(response.description)
            }
        ).catch(
            reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }
        ).finally(
            _ => {
                loading.hide()
            }
        )

    }

    function updateMessageStatus() {
        setButtonLoading(true)
        service.updateMessageInfo(messageId, status).then(
            response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                setRefresh(true)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setButtonLoading(false)
            setRefresh(true)
            handleCloseDialog()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridThreeColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                    disabled={true}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"نام و نام خانوادگی"}
                    value={fullName}
                    setValue={setFullName}
                    disabled={true}
                />
                <RaikoMobileInputOutlined
                    value={phoneNumber}
                    setValue={setPhoneNumber}
                    labelText={"شماره تلفن همراه"}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"ایمیل"}
                    value={email}
                    setValue={setEmail}
                    disabled={true}
                />
                <RaikoDatePicker
                    date={postingDate}
                    setDate={setPostingDate}
                    label={"تاریخ ارسال"}
                />
                <RaikoCustomSelect
                    labelText={"وضعیت"}
                    value={status}
                    setValue={setStatus}
                    items={[
                        raikoCustomSelectItemGenerator("AWAITING_FOR_REVIEW", "در دست بررسی"),
                        raikoCustomSelectItemGenerator("REVIEWED", "بررسی شده")
                    ]}
                />
            </RaikoGridThreeColumn>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                disabled={true}
                value={description}
                setValue={setDescription}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary loading={buttonLoading} label={"بروزرسانی"} onClick={updateMessageStatus}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}